import m from 'mithril';
import dayjs from 'dayjs';
import duration from 'dayjs-duration';
import { Controller } from 'stimulus';

dayjs.extend(duration);

export class CountdownController extends Controller {
  static targets = ['block'];
  static values = {
    date: String, // e.g. "2025-08-26 15:30:00 +02:00"
  };

  connect() {
    if (!this.dateValue) return; // Do nothing if no date

    this.timer = setInterval(() => this.render(), 1000);
    this.render();
  }

  disconnect() {
    clearInterval(this.timer);
  }

  get timeLeft() {
    if (!this.dateValue) return null;

    const end = dayjs(this.dateValue);
    if (!end.isValid()) return null;

    const now = dayjs();
    const diffMs = end.diff(now);

    if (diffMs <= 0) return null;

    return dayjs.duration(diffMs);
  }

  render() {
    const dur = this.timeLeft;

    if (!dur) {
      clearInterval(this.timer);
      return; // Don't render anything when countdown finished or invalid
    }

    m.render(
      this.blockTarget,
      m('div', { class: 'flex space-x-4' }, [
        dur.asDays() >= 1 &&
          m('div', [
            m('div', { class: 'text-3xl lg:text-4xl' }, String(Math.floor(dur.asDays())).padStart(2, '0')),
            m('div', Math.floor(dur.asDays()) === 1 ? 'day' : 'days'),
          ]),

        m('div', [
          m('div', { class: 'text-3xl lg:text-4xl' }, String(dur.hours()).padStart(2, '0')),
          m('div', dur.hours() === 1 ? 'hour' : 'hours'),
        ]),

        m('div', [
          m('div', { class: 'text-3xl lg:text-4xl' }, String(dur.minutes()).padStart(2, '0')),
          m('div', dur.minutes() === 1 ? 'minute' : 'minutes'),
        ]),

        m('div', [
          m('div', { class: 'text-3xl lg:text-4xl' }, String(dur.seconds()).padStart(2, '0')),
          m('div', dur.seconds() === 1 ? 'second' : 'seconds'),
        ]),
      ]),
    );
  }
}

window.Stimulus.register('countdown', CountdownController);
